import { ToastContainer } from 'react-toastify';
import ReactDOM from 'react-dom';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import './index.scss';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import { theme } from './lib/theme';

const appTheme = theme({
  initialColorMode: 'system',
  // useSystemColorMode: false,
});

ReactDOM.render(
  <>
    <ChakraProvider theme={appTheme}>
      <ColorModeScript initialColorMode={appTheme.config.initialColorMode} />
      <App />
    </ChakraProvider>
    <ToastContainer />
  </>,
  document.getElementById('root'),
);
